export default class Notification {
    constructor(api) {
        this.api = api;
        this.NotificationClass = null;
    }

    async init(instance) {
        if (!this.NotificationClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
               await this.api.util.loadJS(instance.data.cdn.js);
               // await this.api.util.loadJS(["http://localhost:8081/widget_notification.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.notification &&
                this.api.settings.widgetsUrl.notification.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.notification.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
               await this.api.util.loadCSS(instance.data.cdn.css);
               //  await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/notification/css/notification.css'])
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.notification &&
                this.api.settings.widgetsUrl.notification.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.notification.css]);
            }
        }

        this.NotificationClass = new window.Widget_notification.default(this.api, instance.instance);
    }
}